<template>
	<div class="file-list-item" :class="{'has-top-meta':dateUploaded || uploadedBy}" v-on:click="mainItemClick">
		<div class="date-uploaded text-muted" v-if="dateUploaded">{{formatDateTimeToLocal(dateUploaded)}}</div>
		<div class="uploaded-by text-muted" v-if="uploadedBy">uploaded by {{uploadedBy}}</div>

		<div class="d-flex flex-row justify-content-between align-items-center main-flex">
			
			<div class="d-flex flex-row flex-wrap align-items-center">
				<input v-if="selectable" type="checkbox" class="select-checkbox mr-2" v-model="selected">

				<div class="mr-3" style="width: 120px;">

					<div v-if="isImageExtension(extension)">
						<image-panel
							:value="{id}"
							:readonly="true"
							:expand-on-click="true"
							:image-url="thumbSrc ? thumbSrc : src"
							:expand-url="src"
							style="max-width: 100px">
						</image-panel>

						<small v-if="sizeKb">{{sizeKb}} kb</small>
					</div>
					<a v-else :href="src" download class="d-flex flex-row align-items-center flex-child">
						<i class="fa fa-2x mr-2" :class="fileIcon" :style="{color:fileColor}"></i>
						
						<small v-if="sizeKb">{{sizeKb}} kb</small>
					</a>
				</div>

				<a :href="src" class="flex-child mr-2 file-label" download><div class="ml-3">
					<template v-if="label">
						{{label}}<br>
						<small class="text-muted">{{filename}}</small>
					</template>
					<span v-else>
						{{filename}}
					</span>
				</div></a>
			</div>
			<div v-if="addedToLabels" class="flex-child mr-2">
				<ul class="file-tags">
					<li v-for="label in addedToLabels" class="badge badge-light text-muted">{{label}}</li>
				</ul>
			</div>
			<div v-if="tags" class="flex-child mr-2">
				<ul class="file-tags">
					<li v-for="tag in tags" class="badge badge-primary">{{tag}}</li>
				</ul>
			</div>
			
			<div class="button-container flex-child">
				<div class="button-inner">

					<button v-for="button in otherButtons" type="button" class="btn btn-sm btn-light" v-on:click="otherButtonClick(button)">
						<i v-if="'icon' in button" class="fa" :class="button.icon"></i>
						{{button.text}}
					</button>

					<a :href="src" v-if="src" download class="btn btn-sm btn-light">
						<i class="fa fa-download"></i>
					</a>
					<template v-if="!nonEditable" >
						<button v-if="!noEditButton" type="button" class="btn btn-light btn-sm edit-button" v-on:click="$emit('editFile')">
							<i class="fa fa-pencil-alt"></i>
						</button>

						<button type="button" class="btn btn-outline-danger btn-sm delete-button" v-on:click="$emit('deleteFile')">
							<i class="fa fa-trash"></i>
						</button>
					</template>
				</div>
			</div>
		</div>

		<slot></slot>

		<div v-if="caption" class="caption">{{caption}}</div>
	</div>
</template>
<script type="text/javascript">
import ImagePanel from "@/components/ImagePanel"

export default {
	name: "FileListItem",
	components: {
		ImagePanel
	},
	props: [
		"id",
		"src", //source to file
		"thumbSrc",
		"label", //optional, if set, label instead of filename
		"filename", //filename label
		"tags",
		"sizeKb",
		"nonEditable",
		"noEditButton",
		"caption",
		"dateUploaded",
		"uploadedBy",
		"selectable",
		"value",
		"otherButtons", // array of other buttons [{text: string,icon: 'fa-pencil',action:string,titleText:string}]
		"addedToLabels"
	],
	data() {
		return  {
			selected: this.value
		}
	},
	watch: {
		value() {
			this.selected = this.value
		},
		selected() {
			this.$emit("selectChange",this.selected)
		}
	},
	computed: {
		extension() {

			let filename = this.filename

			if (!this.filename)
				filename = this.src

			let re = /(?:\.([^.]+))?$/;

			return re.exec(filename)[1];
		},
		fileColor() {
			if (this.extension == "pdf" || this.extension == 'ppt')
				return "red"
			else if (this.extension == "doc" || this.extension == 'docx'  || this.extension == 'rtf' )
				return "blue"
			else if (this.extension == 'xls' || this.extension == 'xlsm'  || this.extension == 'csv' )
				return "#58D68D" //green
			else if (this.extension == 'zip' || this.extension == 'tar'  || this.extension == 'rar' )
				return "#EB984E" //orange
			else
				return "#95A5A6" //gray
		},
		fileIcon() {
			if (this.extension == "pdf") 
				return "fa-file-pdf"
			
			else if (this.extension == "xls" || this.extension == "xlsm") 
				return "fa-file-excel"
			
			else  if (this.extension == "txt") 
				return "fa-file-text"
			
			else if (this.extension == "rtf" || this.extension == "doc" || this.extension == "docx") 
				return "fa-file-word"
			
			else if (this.extension == "zip" || this.extension == "rar" || this.extension == "tar")
				return "fa-file-archive"

			else if (this.extension == 'csv')
				return 'fa-file-csv'

			else 
				return "fa-file"
		}
	},
	methods: {
		mainItemClick() {
			if (this.selectable)
				this.selected = !this.selected
		},
		otherButtonClick(button) {
			this.$emit(button.action)
		}
	}
}

</script>

<style type="text/css" scoped>
	.file-list-item {
		display: block;
		padding: .75rem 1.25rem;
		background-color: #fff;
		border: 1px solid rgba(0,0,0,.125);
		margin-bottom: -1px;
		position: relative;
		margin-bottom: 5px;
	}

	.file-list-item.has-top-meta {
		padding-top: 30px;
	}

	.file-list-item a {
		color: inherit;
		text-decoration: none;
	}

	.file-list-item a {
		word-wrap: break-word;
		overflow-wrap: break-word;
		word-break: break-all;
	}

	.button-container {
		min-width: 66px;
		text-align: right;
	}

	.button-inner {
		display: none;
	}

	.file-list-item:hover .button-inner {
		display: inline-block;
	}

	.file-tags {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.file-tags li.badge {
		margin-right: 3px;
		font-size: 11pt;
	}

	.caption {
		background-color: rgba(10,10,10,0.2);
		margin-top: 10px;
		margin-left: -1.25rem;
		margin-right: -1.25rem;
		margin-bottom: -.75rem;
		padding: 5px;
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.date-uploaded {
		position: absolute;
		top: 3px;
		right: 5px;
		font-size: 10pt;
	}

	.uploaded-by {
		position: absolute;
		top: 3px;
		left: 5px;
		font-size: 10pt;
	}

	@media (max-width: 600px) {
		.main-flex {
			flex-direction: column!important;
		}

		.main-flex .flex-child {
			margin-bottom: 5px;
		}
	}
</style>